import { motion } from "framer-motion";
import { FadeIn } from "./FadeIn";

export function ResultsStrip() {
  return (
    <section className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        {/* Editorial sentence, offset left */}
        <div className="grid lg:grid-cols-12 gap-10 items-start mb-16">
          <FadeIn className="lg:col-span-2">
            <div>
              <span className="text-xs uppercase tracking-[0.28em] text-primary">By the numbers</span>
              <span className="block h-px w-16 bg-primary/60 mt-3" />
              <span className="block text-xs tracking-[0.2em] text-foreground/70 mt-3">III</span>
            </div>
          </FadeIn>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-10 text-3xl md:text-5xl lg:text-[3.5rem] font-normal leading-[1.15] tracking-tight text-foreground"
          >
            Fifteen years turning advisor expertise into{" "}
            <span className="text-primary italic">900 meetings</span> a month
            and roughly <span className="text-primary italic">$50M</span> in
            influenced AUM<span className="text-foreground/70">.</span>
          </motion.p>
        </div>

        {/* Inset forest artifact — floating card, doesn't touch the edges */}
        <FadeIn delay={0.15}>
          <div className="bg-dark text-on-dark rounded-sm px-8 md:px-14 py-14 md:py-16 lg:ml-[16.66%] shadow-[0_30px_80px_-30px_rgba(31,53,41,0.5)]">
            <div className="flex items-baseline justify-between mb-10 border-b border-white/15 pb-5">
              <span className="text-xs uppercase tracking-[0.28em] text-white/90">Ledger</span>
              <span className="text-xs tracking-[0.2em] text-white/70 font-serif italic">
                fig. 01
              </span>
            </div>
            <dl className="grid gap-10 md:[grid-template-columns:repeat(3,minmax(0,1fr))] md:[grid-auto-flow:column]">
              <Metric label="Meetings scheduled" value="900" unit="/ month" />
              <Metric label="AUM influenced" value="$50M" unit="across engagements" />
              <Metric label="Financial services" value="15" unit="years" />
            </dl>
            <p className="mt-10 text-xs tracking-[0.15em] text-white/40 uppercase">
              Results achieved during a 6-month pilot engagement.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}

function Metric({ label, value, unit }: { label: string; value: string; unit: string }) {
  return (
    <>
      <dt className="text-xs uppercase tracking-[0.24em] text-white/50 mb-3 md:[grid-row:1]">
        {label}
      </dt>
      <dd className="md:[grid-row:2] md:mt-0 -mt-6">
        <span className="block font-serif text-5xl md:text-6xl font-normal tracking-tight text-white leading-none">
          {value}
        </span>
        <span className="mt-3 block text-xs text-white/50 tracking-[0.15em] uppercase">{unit}</span>
      </dd>
    </>
  );
}
